const formContent = document.getElementById('new_consumer_family');
const brandList = document.getElementById('brand-list');
const productList = document.getElementById('consumer_family_registries_attributes_0_packing_id')
const codeInput = document.getElementById('consumer_family_registries_attributes_0_serial_number')
const previewSection = document.getElementById('preview-section')
// const contentPdSelected = document.querySelector('.content-product-selected')
const urlParams = new URLSearchParams(window.location.search);
const sku = urlParams.get('sku');
const code = urlParams.get('code');
const prd = urlParams.get('prd');
const host = window.location.hostname;
const categoryName = document.querySelector('.category-name');
const productTitle = document.getElementsByTagName('h1');
const productColorName = document.querySelector('.product-color');
const manualLink = document.getElementById('manual-link');
const manualLinkL = document.getElementById('manual-link-2');
const productInfo = document.getElementById('productInfo');
const getColor = document.getElementById('colorSet');
const pdLinkList = document.getElementById('pd-link-list');
const infoLinks = document.getElementById('info-links');
const sectionForm = document.getElementById('registry-form')

async function getData(apiUrl) {
  const response = await fetch(apiUrl);
  return await response.json();
}
async function inicializar(apiUrl) {
  let data = await getData(apiUrl);
  getUniqueBrands(data);
  getBrandByUrl(host, data);
  getPrdByUrl(prd, data);
  codeFormat();
  // Event change brand
  brandList.addEventListener('change', (e) => {
    let cardPreview = document.getElementById('card-section-preview')
    getProductsByBrand(e.target.value, data);
    cardPreview ? cardPreview.remove() : ''
    // contentPdSelected.classList.remove('d-none');
  });
  // Event change product
  productList.addEventListener('change', (e) => {
    // getProductSelected(data);
    setProductSelected(data);
  });
  codeInput.addEventListener('keyup', codeFormat);
}
// Get brand by Host
async function getBrandByUrl(host, data) {
  function setBrand() {
    brandList.parentElement.parentNode.classList.add('d-none');
    productList.parentElement.parentNode.classList.add('col-md-12');
    getProductsByBrand(brand, data)
  };

  switch (host) {
    case 'coscokids.com.br':
      var brand = 'Cosco Kids';
      setBrand();
      break;
    case 'infanti.com.br':
      var brand = 'Infanti';
      setBrand();
      break;
    case 'maxi-cosi.com.br':
      var brand = 'Maxi-Cosi';
      setBrand();
      break;
    case 'quinny.com.br':
      var brand = 'Quinny';
      setBrand();
      break;
    case 'safety1st.com.br':
      var brand = 'Safety 1st';
      setBrand();
      break;
    case 'tinylove.com.br':
      var brand = 'Tiny Love';
      setBrand();
      break;
    case 'voyageinfantil.com.br':
      var brand = 'Voyage';
      setBrand();
      break;
    default:
      var brand = '';
      brand ? setBrand() : '';
  }
}
// Get data by URL Params
async function getProductByUrl(cod_sku, data) {
  data.map((pd) => {
    let items = pd.items;
    let filter = items.filter(a => a.sku == cod_sku);
    for (let i in filter) {
      let brand = pd.brand_name;
      getProductsByBrand(brand, data);
      // getProductSelected(data);
      setProductSelected(data);
    }
  })
}
// Get unique brand names
async function getUniqueBrands(data) {
  let brand = data.map((pd) => pd.brand_name);
  let unique = [...new Set(brand)];
  unique.sort();
  unique.forEach((brand) => {
    let option = document.createElement('option');
    option.value = brand;
    option.textContent = brand;
    brandList.appendChild(option);
  });
  getProductByUrl(sku, data);
}
// Get products by brand
async function getProductsByBrand(brand, data) {
  let optionBrand = brandList.querySelector(`option[value="${brand}"]`);
  optionBrand.setAttribute('selected', 'selected');
  productList.removeAttribute('disabled');
  productList.innerHTML = '<option>Informar o produto</option>';
  const filteredData = data.filter((brand) => brand.brand_name === brandList.value);

  filteredData.sort((a, b) => a.name.localeCompare(b.name));

  filteredData.map((pd) => {
    let items = pd.items;
    items.map((item) => {
      const optionElement = document.createElement('option')
      optionElement.setAttribute('value', item.packing_id)
      optionElement.setAttribute('data-sku', item.sku)
      optionElement.textContent = `${pd.name} - ${item.color_name} | Ref: ${pd.reference}`
      // optionElement.selected = item.sku == sku ? true : false;
      if (item.sku == sku) {
        optionElement.setAttribute('selected', 'selected');
        // console.log(pd.name, item.color_name, pd.reference, item.packing_id);
      }
      productList.appendChild(optionElement);
    });
  });
}
// Get product selected
// async function getProductSelected(data) {
//   const optionSelected = productList.options[productList.selectedIndex];
//   const selected = optionSelected.getAttribute('data-sku');
//   data.map((pd) => {
//     let items = pd.items;
//     let filter = items.filter(a => a.sku == selected);
//     for (let i in filter) {
//       const cardTemplate = `
//       <div class="row g-0 align-items-center">
//         <div class="col-3 col-md-2">
//           <img src="${filter[i].image_url}" class="img-fluid rounded-start" alt="${pd.name} - ${filter[i].color_name} | ${pd.brand_name}" style="max-width:100px;">
//         </div>
//         <div class="col-9 col-md-8">
//           <div class="card-body">
//             <p class="card-text m-0">
//               <strong>${pd.name}</strong> - ${filter[i].color_name}
//             </p>
//             <p class="card-text m-0">
//               <small class="text-muted">${pd.category} - ${pd.brand_name}</small>
//             </p>
//           </div>
//         </div>
//       </div>`
//     ;
//       const cardRemove = document.getElementById('card-section-preview');
//       let cardSection = document.createElement('section');
//       cardSection.classList.add('card', 'w-100');
//       cardSection.setAttribute('id', 'card-section-preview');
//       cardSection.innerHTML = cardTemplate;
//       cardRemove ? previewSection.replaceChild(cardSection, cardRemove) :
//         previewSection.appendChild(cardSection);
//       contentPdSelected.classList.add('d-none');
//     }
//   });
// }
// SET PRODUCT TO INTRO
async function setProductSelected(data) {
  const optionSelected = productList.options[productList.selectedIndex];
  const selected = optionSelected.getAttribute('data-sku');
  data.map((pd) => {
    let items = pd.items;
    let filter = items.filter(a => a.sku == selected);
    for (let i in filter) {
      const videoContainer = document.getElementsByClassName('video-container');
      const productVideo = `
        <iframe
                  src="https://www.youtube.com/embed/${pd.youtube_code}?modestbranding=1&amp;amp;enablejsapi=1&amp;amp;widgetid=1&amp;amp;rel=0"
                  frameborder="0" title="#{@packing.product.nickname} - #{@packing.brand.brand_name}"
                  data-video="#{@packing.product.youtube_code}"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen="1" data-gtm-yt-inspected-7="true"></iframe>
      `;
      const productImage = `
        <img src="${filter[i].image_url}" class="img-thumbnail" alt="${pd.name} - ${filter[i].color_name} | ${pd.brand_name}" width="50%">
      `;
      let cardPreview = document.createElement('div');
      let cardDel = videoContainer[0];
      cardDel = cardDel.getElementsByTagName('div');
      
      // SET DATA INFO
      productInfo.classList.remove('d-none');
      pdLinkList.classList.add('d-none');
      infoLinks.classList.remove('d-none');
      categoryName.textContent = pd.category;
      productTitle[0].textContent = pd.name;
      productColorName.textContent = filter[i].color_name;
      manualLink.href = pd.manual;
      pd.youtube_code ? cardPreview.innerHTML = productVideo : cardPreview.innerHTML = productImage;
      cardDel[0] ? videoContainer[0].replaceChild(cardPreview, cardDel[0]) : videoContainer[0].appendChild(cardPreview);
    }
  });
}
// Get product by PRD params
async function getPrdByUrl(prd, data) {
  let filter = data.filter(a => a.id == prd);
  let brand = filter[0].brand_name;
  let optionBrand = brandList.querySelector(`option[value="${brand}"]`);
  let colorList = document.createElement('select');
  colorList.classList.add('form-select', 'mt-3');
  optionBrand.setAttribute('selected', 'selected');
  productList.removeAttribute('disabled');
  productList.innerHTML = '<option>Informar o produto</option>';
  brandList.parentElement.parentNode.classList.add('d-none');
  productList.parentElement.parentNode.classList.add('col-md-12');
  colorList.innerHTML = '<option>Selecione uma cor</option>';

  categoryName.textContent = filter[0].category;
  productTitle[0].textContent = filter[0].name;
  manualLink.setAttribute('href', filter[0].manual);
  // console.log(filter[0].youtube_code)

  const videoContainer = document.getElementsByClassName('video-container');
  const productVideo = `
    <iframe
              src="https://www.youtube.com/embed/${filter[0].youtube_code}?modestbranding=1&amp;amp;enablejsapi=1&amp;amp;widgetid=1&amp;amp;rel=0"
              frameborder="0" title="#{@packing.product.nickname} - #{@packing.brand.brand_name}"
              data-video="#{@packing.product.youtube_code}"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen="1" data-gtm-yt-inspected-7="true"></iframe>
  `;
  const productImage = `
    <img src="${filter[0].items[0].image_url}" class="img-thumbnail" alt="${filter[0].name} - ${filter[0].items[0].color_name} | ${filter[0].brand_name}" width="50%">
  `;

  let cardPreview = document.createElement('div');
  let cardDel = videoContainer[0];
  cardDel = cardDel.getElementsByTagName('div');

  filter[0].youtube_code ? cardPreview.innerHTML = productVideo : cardPreview.innerHTML = productImage;
  cardDel[0] ? videoContainer[0].replaceChild(cardPreview, cardDel[0]) : videoContainer[0].appendChild(cardPreview);

  filter.sort((a, b) => a.name.localeCompare(b.name));
  filter.map((pd) => {
    let items = pd.items;
    items.map((item) => {
      const optionElement = document.createElement('option')
      optionElement.setAttribute('value', item.packing_id)
      optionElement.setAttribute('data-sku', item.sku)
      optionElement.textContent = `${pd.name} - ${item.color_name} | Ref: ${pd.reference}`
      productList.appendChild(optionElement);
    });
  });

  // filter[0].items.forEach((item) => {
  //   let option = document.createElement('option');
  //   option.value = item.color_name;
  //   option.setAttribute('data-color', item.sku);
  //   option.textContent = item.color_name;
  //   colorList.appendChild(option);
  // });
  // getColor.innerHTML = colorList.outerHTML;
  productInfo.classList.remove('d-none');
  // pdLinkList.classList.remove('d-none');

  // getColor.addEventListener('change', (e) => {
  //   const selectedOption = e.target.options[e.target.selectedIndex];
  //   const cod_sku = selectedOption.getAttribute('data-color');
  //   const options = productList.options;
  //   for (let i = 0; i < options.length; i++) {
  //     if (options[i].getAttribute('data-sku') === cod_sku) {
  //     options[i].selected = true;
  //     setProductSelected(data)
  //     break;
  //     }
  //   }
  // });
}
// Initialize URL API
inicializar('https://api.dorel.com.br/v1/catalog/product_assistances');

// VALIDATE CODE
async function codeFormat() {
  if (code) {
    var v = code.replace(/\D/g, "");
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    codeInput.value = v;
    if (codeInput.value !== "") {
      codeInput.classList.remove('is-invalid');
      codeInput.classList.add('is-valid');
    }
  } else {
    var v = codeInput.value.replace(/\D/g, "");
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    codeInput.value = v;
    if (codeInput.value !== "") {
      codeInput.classList.remove('is-invalid');
      codeInput.classList.add('is-valid');
    }
  }
}
// VALIDATE FILE UPLOAD
// const fileInput = document.getElementById('capture');
// const validFile = document.getElementById('valid-file');
// fileInput.addEventListener('change', (e) => {
//   const file = e.target.files[0];
//   const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
//   const maxSize = 5 * 1024 * 1024; // 5MB

//   if (file) {
//     if (!allowedTypes.includes(file.type)) {
//       validFile.textContent = 'Por favor, selecione um arquivo JPG, PNG ou PDF.';
//       fileInput.classList.add('is-invalid');
//       fileInput.value = ''; // Clear the file input
//       return;
//     } else {
//       fileInput.classList.remove('is-invalid');
//       fileInput.classList.add('is-valid');
//     };

//     if (file.size > maxSize) {
//       validFile.textContent = 'O tamanho máximo do arquivo é de 5MB.';
//       fileInput.classList.add('is-invalid');
//       fileInput.value = ''; // Clear the file input
//       return;
//     } else {
//       fileInput.classList.remove('is-invalid');
//       fileInput.classList.add('is-valid');
//     };
//   }
// });
// VALIDATE CPF
const documentNumber = document.getElementById('consumer_family_parents_attributes_0_cpf');
documentNumber.addEventListener('keyup', formatarDocumentNumber);
function formatarDocumentNumber(e) {
  var v = e.target.value.replace(/\D/g, "");
  v = v.replace(/(\d{3})(\d)/, "$1.$2");
  v = v.replace(/(\d{3})(\d)/, "$1.$2");
  v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  e.target.value = v;
}
function validarCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, ''); // Remove tudo que não é dígito

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false; // CPF deve ter 11 dígitos e não pode ser uma sequência repetida
  }

  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }

  let resto = 11 - (soma % 11);
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  if (resto !== parseInt(cpf.charAt(9))) {
    return false;
  }

  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }

  resto = 11 - (soma % 11);
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  if (resto !== parseInt(cpf.charAt(10))) {
    return false;
  }

  return true;
}
function validDocument() {
  let cpf = documentNumber.value;
  if (validarCPF(cpf)) {
    documentNumber.classList.remove('is-invalid');
    documentNumber.classList.add('is-valid');
  } else {
    documentNumber.classList.add('is-invalid');
  }
}
// VALIDATE EMAIL  
const email = document.getElementById('consumer_family_parents_attributes_0_email')
email.addEventListener("change", () => {
  if (validatorEmail(email.value) !== true) {
    email.classList.add('is-invalid');
  } else {
    email.classList.remove('is-invalid');
    email.classList.add('is-valid');
  }
});
function validatorEmail(email) {
  let emailPattern =
    /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
  return emailPattern.test(email);
}
// VALIDATE PHONE
const cellphoneNumber = document.getElementById('consumer_family_parents_attributes_0_cellphone');
cellphoneNumber.addEventListener('keyup', formatarTelefone);
function formatarTelefone(e) {
  var v = e.target.value.replace(/\D/g, "");
  v = v.replace(/^(\d\d)(\d)/g, "($1) $2");
  v = v.replace(/(\d{5})(\d)/, "$1-$2");
  e.target.value = v;
  if (cellphoneNumber.value !== "") {
    cellphoneNumber.classList.remove('is-invalid');
    cellphoneNumber.classList.add('is-valid');
  }
}
// VALIDATE CEP
// const cep = document.getElementById('consumer_family_addresses_attributes_0_zipcode')
// cep.addEventListener('keyup', formatarCep);
// function formatarCep(e) {
//   var v = e.target.value.replace(/\D/g, "")
//   v = v.replace(/^(\d{5})(\d)/, "$1-$2")
//   e.target.value = v;
//   if (cep.value !== "") {
//     cep.classList.remove('is-invalid');
//     cep.classList.add('is-valid');
//   }
// }
// GET INFO ADDRESS
// cep.addEventListener('blur', (e) => {
//   let search = cep.value.replace('-', '')
//   console.log(search)
//   async function getDataAddress() {
//     const response = await fetch(`https://viacep.com.br/ws/${search}/json/`);
//     const data = await response.json();

//     for (const field in data) {
//       if (document.querySelector(`.${field}`)) {
//         document.querySelector(`.${field}`).value = data[field]
//       }
//     }
//   }
//   getDataAddress()
// })
// CREATE AND REMOVE NESTED GROUP INPUTS
// Adicionar campos
function addInputFields() {
  const timestamp = Date.now();
  const div = document.createElement('div');
  div.className = 'col';
  div.id = `form-group-${timestamp}`;

  // Cria o HTML interno do container com os campos, utilizando o timestamp para criar IDs únicos
  div.innerHTML = `
    <div class="row row-gap-3 mb-3">
      <div class="col-12 col-md-12">
        <div class="form-floating">
          <input class="form-control" type="text" name="consumer_family[children_attributes][${timestamp}][name]"
            id="consumer_family_children_attributes_${timestamp}_name" placeholder="Nome">
          <label for="consumer_family_children_attributes_${timestamp}_name">Nome</label>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="form-floating">
          <input class="form-control" type="date" name="consumer_family[children_attributes][${timestamp}][age]"
            id="consumer_family_children_attributes_${timestamp}_age">
          <label for="consumer_family_children_attributes_${timestamp}_age">Data de Nascimento</label>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="form-floating">
          <select class="form-select" name="consumer_family[children_attributes][${timestamp}][gender]"
            id="consumer_family_children_attributes_${timestamp}_gender" aria-label="Genero">
            <option selected>Selecione uma Opção</option>
            <option value="0">Feminino</option>
            <option value="1">Masculino</option>
            <option value="2">Não sei ainda</option>
          </select>
          <label for="consumer_family_children_attributes_${timestamp}_gender">Sexo</label>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="d-grid gap-2 d-md-flex justify-content-md-around" style="height: 78%;">
          <button class="btn btn-danger minus-group btn-lg" type="button" style="width: 100%;"
            onclick="removeInputFields(this)">Remover</button>
        </div>
      </div>
    </div>
  `;

  // Adiciona o novo container de campos ao elemento pai
  document.getElementById('form-groups').appendChild(div);
}
// Remover campos
function removeInputFields(element) {
  element.closest('.col').remove();
}
// Clique para adicionar campos
document.getElementById('addButton').addEventListener('click', (e) => {
  e.preventDefault();
  addInputFields();
});
// Valid checkbox terms
const terms = document.getElementById('consumer_family_parents_attributes_0_terms_accepted');
const termsParent = terms.parentElement;
const termsDiv = termsParent.classList.contains('terms-check')

terms.addEventListener('change', () => {
  if (terms.checked) {
    terms.classList.remove('is-invalid');
    termsParent.classList.remove('alert', 'alert-danger', 'px-5');
    terms.value = '1';
  } else {
    terms.value = '';
    terms.classList.add('is-invalid');
    termsParent.classList.add('alert', 'alert-danger', 'px-5');
  }
});

// DATA SEND FORM
function sendForm(e) {
  e.preventDefault();

  // Check if all required fields are filled
  if (formContent.checkValidity()) {
    // Disable the submit button
    const botaoEnviar = document.getElementById('sendForm');
    botaoEnviar.disabled = true;

    // Loading form to send
    const loadSend = document.getElementById('loadSend');
    loadSend.classList.remove('d-none');

    const formData = new FormData(formContent);

    fetch('https://api.dorel.com.br/v1/consumer/registries', {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log('Resposta do servidor:', data);
        document.querySelector('.alert-success').classList.remove('d-none');
        document.querySelector('.alert-danger').classList.add('d-none');
        loadSend.classList.add('d-none');
        botaoEnviar.disabled = false;
      })
      .catch(error => {
        console.error('Erro:', error);
        document.querySelector('.alert-danger').classList.remove('d-none');
        document.querySelector('.alert-success').classList.add('d-none');
        botaoEnviar.disabled = false;
      });

  } else {
    // List all required fields
    const requiredFields = Array.from(formContent.querySelectorAll('[required]'));
    requiredFields.forEach(field => {
      if (field.value.trim() === '') {
        document.getElementById(field.id).classList.add('is-invalid');
        document.querySelector('.alert-danger').classList.remove('d-none');
        document.querySelector('.alert-success').classList.add('d-none');
        termsParent.classList.add('alert', 'alert-danger', 'px-5');
      }
    });
  }
  scrollToTop();
}
formContent.addEventListener('keypress', function (e) {
  if (e.key === 'Enter' && e.target.tagName !== 'BUTTON') { e.preventDefault(); }
});
formContent.addEventListener('submit', sendForm);
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

const items = document.querySelectorAll('.accordionFaq button');
function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded');

  for (i = 0; i < items.length; i++) {
    items[i].setAttribute('aria-expanded', 'false');
  }

  if (itemToggle == 'false') {
    this.setAttribute('aria-expanded', 'true');
  }
}
items.forEach((item) => item.addEventListener('click', toggleAccordion));

function scrollToForm() {
  const navHeight = 87;
  const formPosition = sectionForm.getBoundingClientRect().top + window.scrollY - navHeight;
  window.scrollTo({
    top: formPosition,
    behavior: 'smooth'
  });
}